<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="基本信息"></a-form-item>
        <!--                <div class="editBtn">-->
        <!--                  <a-button @click="update" type="link" icon="edit">修改</a-button>-->
        <!--                </div>-->

        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="基金代码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                :minLength="6"
                :maxLength="6"
                autocomplete="off"
                v-decorator="['fundCode', validatorRules.fundCode]"
                placeholder="请输入基金代码"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="基金全称"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                :maxLength="100"
                autocomplete="off"
                v-decorator="['fundName', validatorRules.fundName]"
                placeholder="请输入基金名称"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="基金简称"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['fundShortName', validatorRules.fundShortName]"
                placeholder="请输入基金简称"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="产品类型"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['fundType', validatorRules.fundType]"
                :trigger-change="true"
                dictCode="fund_type"
                :placeholder="'请选择基金类型'"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="风险等级"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['fundRisk', validatorRules.fundRisk]"
                :trigger-change="true"
                dictCode="fund_risk"
                :placeholder="'请选择风险等级'"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="收费类型"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['fundChargeType', validatorRules.fundChargeType]"
                :trigger-change="true"
                dictCode="fee_type"
                :placeholder="'请选择收费类型'"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="基金状态"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['fundStatus', validatorRules.fundStatus]"
                :trigger-change="true"
                dictCode="fund_status"
                :placeholder="'请选择基金状态'"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="资金规模(元)"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="['fundSize']"
                placeholder="请输入资金规模(元)"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="产品管理人"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['fundAdministrator']"
                placeholder="请输入基金关管理人"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="产品托管人"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['fundTrustee']"
                placeholder="请输入基金托管人"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="产品评级"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['fundGrade']"
                placeholder="请输入产品评级"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="起投金额(元)"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['fundMinAmount']"
                placeholder="请输入起投金额(元)"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="运作方式"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['operationType']"
                :trigger-change="true"
                dictCode="fund_operate_mode"
                placeholder="请选择运作方式"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="基金标签"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                mode="tags"
                v-decorator="['fundTags']"
                style="width: 100%;position: relative "
                placeholder="请选择"
                @change="handleChange"
                :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode;
                  }
                "
              >
                <a-select-option key="fundRisk">风险等级</a-select-option>
                <a-select-option key="fundType">产品类型</a-select-option>
                <a-select-option key="fundMinAmount">起投金额</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="是否ETF基金"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['isEtf']"
                :trigger-change="true"
                dictCode="IS_ETF"
                placeholder="请选择是否ETF基金"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="产品发行信息"></a-form-item>
        <!--                <div class="editBtn">-->
        <!--                  <a-button @click="update" type="link" icon="edit">修改</a-button>-->
        <!--                </div>-->
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="募集开始时间"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择募集开始时间"
                v-decorator="['raiseBeginDate']"
                :trigger-change="true"
                dateFormat="YYYY-MM-DD"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="募集结束时间"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择募集结束时间"
                v-decorator="['raiseEndDate']"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="锁定期"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['knockDate']"
                placeholder="请输入锁定期"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="封闭期"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['closeDate']"
                placeholder="请输入封闭期"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="成立时间"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="成立时间"
                v-decorator="['foundedDate']"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="控制信息"></a-form-item>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="默认分红方式"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-dict-select-tag
                type="list"
                v-decorator="['dividendType']"
                :trigger-change="true"
                dictCode="dividend_type"
                placeholder="请选择默认分红方式"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="是否允许修改分红方式"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['dividendTypeFlag']"
                placeholder="请选择是否允许修改分红方式"
              >
                <a-select-option value="1">是</a-select-option>
                <a-select-option value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="是否可定投"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['aipFlag']"
                placeholder="请选择是否可定投"
              >
                <a-select-option value="1">是</a-select-option>
                <a-select-option value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="买入T+N确认份额"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['day1']"
                placeholder="请选择买入T+N确认份额"
              >
                <a-select-option value="1">1</a-select-option>
                <a-select-option value="2">2</a-select-option>
                <a-select-option value="3">3</a-select-option>
                <a-select-option value="4">4</a-select-option>
                <a-select-option value="5">5</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="买入T+N查看收益"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['day2']"
                placeholder="请选择买入T+N查看收益"
              >
                <a-select-option value="1">1</a-select-option>
                <a-select-option value="2">2</a-select-option>
                <a-select-option value="3">3</a-select-option>
                <a-select-option value="4">4</a-select-option>
                <a-select-option value="5">5</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="卖出T+N确认份额"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['day3']"
                placeholder="请选择卖出T+N确认份额"
              >
                <a-select-option value="1">1</a-select-option>
                <a-select-option value="2">2</a-select-option>
                <a-select-option value="3">3</a-select-option>
                <a-select-option value="4">4</a-select-option>
                <a-select-option value="5">5</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-item
              label="卖出T+N资金到账"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-decorator="['day4']"
                placeholder="请选择卖出T+N资金到账"
              >
                <a-select-option value="1">1</a-select-option>
                <a-select-option value="2">2</a-select-option>
                <a-select-option value="3">3</a-select-option>
                <a-select-option value="4">4</a-select-option>
                <a-select-option value="5">5</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="相关配置"></a-form-item>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12" v-show="this.form.getFieldValue('fundType') == 2">
            <a-form-item
              label="前端显示索引"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                autocomplete="off"
                v-decorator="['indexSort']"
                placeholder="请输入索引排序"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="搜索时展示业绩"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-checkbox-group
                style="width: 100%;"
                v-decorator="['dispPointer']"
                @change="onChange"
              >
                <a-row>
                  <a-col :span="8">
                    <a-checkbox value="fluctuateper">
                      日涨幅
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="weekGrothRate">
                      近一周
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="monthGrothrRate">
                      近一月
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="qGrothRate">
                      近三月
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="hyearGrothRate">
                      近半年
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="thisYearGrothRate">
                      今年以来
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="yearGrothRate" :defaultChecked="true">
                      近一年
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="dyearGrothRate">
                      近两年
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="tyearGrothRate">
                      近3年
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="fundGrothRate">
                      成立以来
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="incomdepercent">
                      七日年化
                    </a-checkbox>
                  </a-col>
                  <a-col :span="8">
                    <a-checkbox value="dividendAmount">
                      万份收益
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <a-col :span="12">
            <a-form-model-item
              label="所属渠道"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                mode="multiple"
                style="width: 100%"
                v-model="channelCodes"
                placeholder="请选择所属渠道"
              >
                <a-select-option
                  v-for="item in channelList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-item label="产品概况（描述）"></a-form-item>
        <!--                <div class="editBtn">-->
        <!--                  <a-button @click="update" type="link" icon="edit">修改</a-button>-->
        <!--                </div>-->
        <a-form-item
          label="投资理念"
          :labelCol="labelCols"
          :wrapperCol="wrapperCols"
        >
          <a-textarea
            v-decorator="['investmentPhilosophy']"
            placeholder="请输入投资理念"
            :maxLength="800"
          ></a-textarea>
        </a-form-item>
        <a-form-item
          label="投资策略"
          :labelCol="labelCols"
          :wrapperCol="wrapperCols"
        >
          <a-textarea
            v-decorator="['investmentStrategy']"
            placeholder="请输入投资策略"
            :maxLength="800"
          ></a-textarea>
        </a-form-item>
        <a-form-item
          label="投资范围"
          :labelCol="labelCols"
          :wrapperCol="wrapperCols"
        >
          <a-textarea
            v-decorator="['investmentScope']"
            placeholder="请输入投资范围"
            :maxLength="800"
          ></a-textarea>
        </a-form-item>
        <a-form-item
          label="业绩比较基准"
          :labelCol="labelCols"
          :wrapperCol="wrapperCols"
        >
          <a-textarea
            v-decorator="['bchmkDesc']"
            placeholder="请输入业绩比较基准"
            :maxLength="800"
          ></a-textarea>
        </a-form-item>
        <a-form-item
          label="风险收益特征"
          :labelCol="labelCols"
          :wrapperCol="wrapperCols"
        >
          <a-textarea
            v-decorator="['riskReturnCharacteristics']"
            placeholder="请输入风险收益特征"
            :maxLength="800"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';

export default {
  name: 'FundInfoModal',
  components: {
    JDate,
    JDictSelectTag
  },
  data() {
    return {
      form: this.$form.createForm(this),
      manaName: '',
      title: '操作',
      width: 1000,
      visible: false,
      organizationVisible: false,
      organizationLoading: false,
      model: {},
      activeKey: '',
      dataSelect: [],
      dataListSelections: [],
      channelCodes: [],
      channelList: [],
      pageSize: 10,
      pageIndex: 1,
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      ids: '',
      fundCode: '',
      labelCol: {
        xs: { span: 22 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCols: {
        xs: { span: 20 },
        sm: { span: 5 }
      },
      wrapperCols: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        fundCode: {
          rules: [
            { required: true, message: '请输入基金代码!' },
            {
              min: 6,
              message: '请输入6位基金代码!'
            },
            {
              max: 6,
              message: '请输入6位基金代码!'
            },
            //{ validator: (rule,value,callback) => {validateFundCode(rule, value, callback)}},
            {
              validator: (rule, value, callback) =>
                validateDuplicateValue(
                  'products_fundinfo',
                  'fund_code',
                  value,
                  this.model.id,
                  callback
                )
            }
          ]
        },
        fundName: { rules: [{ required: true, message: '请输入基金名称!' }] },
        fundType: { rules: [{ required: true, message: '请输入基金类型!' }] },
        fundStatus: { rules: [{ required: true, message: '请输入基金状态!' }] },
        fundChargeType: {
          rules: [{ required: true, message: '请输入收费类型!' }]
        },
        fundRisk: { rules: [{ required: true, message: '请输入风险等级!' }] },
        fundShortName: {
          rules: [{ required: true, message: '请输入基金简称!' }]
        },
        foundedDate: {
          rules: [{ required: true, message: '请输入成立日期!' }]
        },
        fundMinAmount: {
          rules: [{ required: true, message: '请输入起投金额!' }]
        }
      },
      url: {
        add: process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/add',
        edit: process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/edit'
      }
    };
  },
  created() {},
  methods: {
    callback(key) {
      if (key === '2') {
        this.getManageList();
        if (this.model.fundCode) {
          this.getProductsRelevanceList(this.model.fundCode);
        } else {
          this.productsRelevanceList = [];
        }
      }
      if (key === '3') {
        if (this.model.fundCode) {
          this.getOrganizationList(this.model.fundCode);
        } else {
          this.organizationList = [];
        }
      }
      this.activeKey = key;
      console.log(key === '2');
    },
    add() {
      this.activeKey = '1';
      this.edit({});
    },
    edit(record) {
      this.activeKey = '1';
      this.fundCode = record.fundCode;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      if (!this.model.id) {
        this.model.aipFlag = '1';
        this.model.dividendType = '1';
        this.model.dividendTypeFlag = '1';
        this.model.isEtf = '0';
      }
      this.model.fundTags = [];
      this.channelCodes = ['h5_trade_service'];
      if (record.dispPointer) {
        this.model.dispPointer = this.model.dispPointer.split(',');
      }
      if (!record.dispPointer) {
        this.model.dispPointer = [];
        this.model.dispPointer.push('yearGrothRate');
      }
      if (record.fundTag1) {
        this.model.fundTags.push(record.fundTag1);
      }
      if (record.fundTag2) {
        this.model.fundTags.push(record.fundTag2);
      }
      if (record.fundTag3) {
        this.model.fundTags.push(record.fundTag3);
      }
      this.visible = true;
      console.log(this.model);
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'fundCode',
            'fundName',
            'fundType',
            'fundStatus',
            'fundRisk',
            'fundMinAmount',
            'checked',
            'isdelete',
            'fundShortName',
            'fundEmitdate',
            'fundEname',
            'initCount',
            'fundSize',
            'fundSale',
            'recommandReason',
            'appendMinAmount',
            'fundAdministrator',
            'fundTrustee',
            'fundHyplink',
            'raiseBeginDate',
            'raiseEndDate',
            'isSupermoney',
            'canFixed',
            'fundNew',
            'taCode',
            'operationType',
            'fundGrade',
            'dividendType',
            'liquidationDate',
            'issuePrice',
            'currency',
            'raiseRental',
            'fundChargeType',
            'fundOpenDate',
            'fundDueDate',
            'deadline',
            'managerRate',
            'trusteeshipRate',
            'salesServiceRate',
            'fundLowestRate',
            'investmentPhilosophy',
            'participationThreshold',
            'investmentObjective',
            'investmentScope',
            'mainRisk',
            'fundFeatures',
            'raiseFundCode',
            'raiseMoneyFloor',
            'raiseMoneyUpper',
            'raiseOpenDate',
            'raiseOverDate',
            'raiseRate',
            'subscribeFundCode',
            'subscribeMoneyFloor',
            'subscribeMoneyUpper',
            'subscribeOpenDate',
            'subscribeOverDate',
            'subscribeRate',
            'redeemFundCode',
            'redeemHoldFloor',
            'redeemHoldUpper',
            'redeemOpenDate',
            'redeemOverDate',
            'redeemRate',
            'transitionFundCode',
            'adverseFundCode',
            'adverseChargeType',
            'transitionHoldFloor',
            'transitionHoldUpper',
            'transitionOpenDate',
            'transitionOverDate',
            'transitionRate',
            'fixedFundCode',
            'fixedMoneyFloor',
            'fixedMoneyUpper',
            'fixedOpenDate',
            'fixedOverDate',
            'fixedRate',
            'fundLowestRedeemLot',
            'fundHighestRedeemLot',
            'fundLowestTransitionLot',
            'fundLowestHoldLot',
            'firstCriterion',
            'highestRaiseMoney',
            'highestSubscribeMoney',
            'firstsubscribeLowestMoney',
            'addsubscribeLowestMoney',
            'firstraiseLowestMoney',
            'addraiseLowestMoney',
            'fixedLowestMoney',
            'fixedHighestMoney',
            'manaName',
            'startDate',
            'endDate',
            'tenureReport',
            'noticeId',
            'noticeTitle',
            'noticeType',
            'releaseStatus',
            'releaseDate',
            'createUser',
            'createUser',
            'createUser',
            'createDate',
            'createDate',
            'createDate',
            'relatedProducts',
            'relatedProducts',
            'relatedProducts',
            'operation',
            'operation',
            'operation',
            'tradeDate',
            'tradeDate',
            'intraday',
            'intraday',
            'nearlyOneWeek',
            'nearlyOneWeek',
            'nearlyOneMonth',
            'nearlyOneMonth',
            'nearlyThreeMonths',
            'nearlyThreeMonths',
            'nearlySixMonths',
            'nearlySixMonths',
            'nearlyOneYear',
            'nearlyOneYear',
            'fromThisYear',
            'fromThisYear',
            'assetPortfolio',
            'industrialDistribution',
            'topTenStock',
            'topFiveBond',
            'productDescritption',
            'productRiskHint',
            'productContract',
            'electronicSignatureBook',
            'foundedDate',
            'foundedSize',
            'dispPointer',
            'dividendType',
            'day1',
            'day2',
            'day3',
            'day4',
            'fundTags',
            'aipFlag',
            'dividendTypeFlag',
            'investmentStrategy',
            'bchmkDesc',
            'riskReturnCharacteristics',
            'knockDate',
            'closeDate',
            'indexSort',
            'isEtf'
          )
        );
      });
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryAll',
        {}
      ).then(res => {
        if (res.success) {
          this.channelList = res.result;
        } else {
          this.$message.warning(res.message);
        }
      });
      if (this.model.id) {
        getAction(
          process.env.VUE_APP_CMS_PRODUCT +
            '/admin/product/fundInfo/queryChannelById',
          { productId: this.model.id }
        ).then(res => {
          if (res.success) {
            this.channelCodes = res.result;
          } else {
            this.$message.warning(res.message);
          }
        });
      }

      console.log('form:' + this.form);
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          console.log('model', this.model);
          let formData = Object.assign(this.model, values);
          console.log('model', this.model);
          console.log(this.model.fundTags);
          console.log(formData.fundTags);
          formData.dispPointer = `${formData.dispPointer}`;
          if (formData.fundTags && formData.fundTags.length > 0) {
            formData.fundTag1 = '';
            formData.fundTag2 = '';
            formData.fundTag3 = '';
            formData.fundTags.forEach((item, index) => {
              formData['fundTag' + (index + 1)] = item;
            });
          }
          formData.channelCodes = `${this.channelCodes}`;
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'fundCode',
          'fundName',
          'fundType',
          'fundStatus',
          'fundRisk',
          'fundMinAmount',
          'checked',
          'isdelete',
          'fundShortName',
          'fundEmitdate',
          'fundEname',
          'initCount',
          'fundSize',
          'fundSale',
          'recommandReason',
          'appendMinAmount',
          'fundAdministrator',
          'fundTrustee',
          'fundHyplink',
          'raiseBeginDate',
          'raiseEndDate',
          'isSupermoney',
          'canFixed',
          'fundNew',
          'taCode',
          'operationType',
          'fundGrade',
          'dividendType',
          'liquidationDate',
          'issuePrice',
          'currency',
          'raiseRental',
          'fundChargeType',
          'fundOpenDate',
          'fundDueDate',
          'deadline',
          'managerRate',
          'trusteeshipRate',
          'salesServiceRate',
          'fundLowestRate',
          'investmentPhilosophy',
          'participationThreshold',
          'investmentObjective',
          'investmentScope',
          'mainRisk',
          'fundFeatures',
          'raiseFundCode',
          'raiseMoneyFloor',
          'raiseMoneyUpper',
          'raiseOpenDate',
          'raiseOverDate',
          'raiseRate',
          'subscribeFundCode',
          'subscribeMoneyFloor',
          'subscribeMoneyUpper',
          'subscribeOpenDate',
          'subscribeOverDate',
          'subscribeRate',
          'redeemFundCode',
          'redeemHoldFloor',
          'redeemHoldUpper',
          'redeemOpenDate',
          'redeemOverDate',
          'redeemRate',
          'transitionFundCode',
          'adverseFundCode',
          'adverseChargeType',
          'transitionHoldFloor',
          'transitionHoldUpper',
          'transitionOpenDate',
          'transitionOverDate',
          'transitionRate',
          'fixedFundCode',
          'fixedMoneyFloor',
          'fixedMoneyUpper',
          'fixedOpenDate',
          'fixedOverDate',
          'fixedRate',
          'fundLowestRedeemLot',
          'fundHighestRedeemLot',
          'fundLowestTransitionLot',
          'fundLowestHoldLot',
          'firstCriterion',
          'highestRaiseMoney',
          'highestSubscribeMoney',
          'firstsubscribeLowestMoney',
          'addsubscribeLowestMoney',
          'firstraiseLowestMoney',
          'addraiseLowestMoney',
          'fixedLowestMoney',
          'fixedHighestMoney',
          'manaName',
          'startDate',
          'endDate',
          'tenureReport',
          'noticeId',
          'noticeTitle',
          'noticeType',
          'releaseStatus',
          'releaseDate',
          'createUser',
          'createUser',
          'createUser',
          'createDate',
          'createDate',
          'createDate',
          'relatedProducts',
          'relatedProducts',
          'relatedProducts',
          'operation',
          'operation',
          'operation',
          'tradeDate',
          'tradeDate',
          'intraday',
          'intraday',
          'nearlyOneWeek',
          'nearlyOneWeek',
          'nearlyOneMonth',
          'nearlyOneMonth',
          'nearlyThreeMonths',
          'nearlyThreeMonths',
          'nearlySixMonths',
          'nearlySixMonths',
          'nearlyOneYear',
          'nearlyOneYear',
          'fromThisYear',
          'fromThisYear',
          'assetPortfolio',
          'industrialDistribution',
          'topTenStock',
          'topFiveBond',
          'productDescritption',
          'productRiskHint',
          'productContract',
          'electronicSignatureBook',
          'dispPointer',
          'dividendType',
          'day1',
          'day2',
          'day3',
          'day4',
          'fundTags',
          'aipFlag',
          'dividendTypeFlag',
          'investmentStrategy',
          'bchmkDesc',
          'riskReturnCharacteristics',
          'knockDate',
          'closeDate',
          'indexSort',
          'isEtf'
        )
      );
    },
    onChange(checkedValues) {
      console.log('checked = ', checkedValues);
      if (checkedValues.length > 1) {
        this.form.setFieldsValue({ dispPointer: checkedValues.splice(0, 1) });
        console.log(checkedValues);
      }
    },
    handleChange(value) {
      this.dataSelect = `${value}`;
      if (value.length > 3) {
        this.form.setFieldsValue({ fundTags: value.splice(0, 1) });
        console.log(value);
      }
      console.log(this.dataSelect);
    }
  }
};
</script>
<style scoped lang="less">
.editBtn {
  display: block;
  float: left;
  width: 100%;
  height: auto;
  .ant-btn {
    float: right;
    margin-top: -55px;
    margin-bottom: 10px;
  }
}
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
